module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/HowToFileClaimSection/tracking-72a6db06616fd366cc8ace463d8ec68b.png";